var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-addEdit',{ref:"addEdit",attrs:{"formList":_vm.formList,"addParam":_vm.addParam}})}
var staticRenderFns = []

export { render, staticRenderFns }